import { Checkbox, DataSource, ExcludableTextbox, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutFUTAReport extends Layout {
    checkboxReverseVoids: Checkbox;
    excludabletextboxPayee: ExcludableTextbox;
    sourceFUTAReports: DataSource;
    textboxDateRange: Textbox;
}
